const p = () => typeof window < "u", R = () => window.self !== window.top, b = (e) => e instanceof HTMLIFrameElement, M = (e) => {
  window.document.readyState === "complete" ? e() : window.addEventListener("load", e);
}, T = (e, t) => {
  t(), e.addEventListener("load", t);
}, C = (e, t) => {
  var o, r;
  const n = ((o = e.contentWindow) == null ? void 0 : o.document.readyState) === "complete";
  return e.src !== "about:blank" && ((r = e.contentWindow) == null ? void 0 : r.location.href) !== "about:blank" && n ? t() : e.addEventListener("load", t);
}, k = () => ({ offsetSize: 0, checkOrigin: !0, enableLegacyLibSupport: !1 }), B = (e) => {
  try {
    return new URL(e.src).origin === window.location.origin;
  } catch {
    return !1;
  }
}, D = (e) => {
  try {
    const t = new URL(e.src).origin;
    if (t !== "about:blank")
      return t;
  } catch {
  }
  return null;
}, A = (e) => (Object.keys(e).forEach((t) => e[t] === void 0 && delete e[t]), e), L = (e) => {
  const { height: t, width: n } = e.getBoundingClientRect();
  return { height: Math.ceil(t), width: Math.ceil(n) };
}, f = (e, t) => e ? t ? e.querySelector(t) : e.documentElement : null, I = (e, t) => {
  e && (t.bodyPadding && (e.body.style.padding = t.bodyPadding), t.bodyMargin && (e.body.style.margin = t.bodyMargin));
}, m = (e) => e <= 100 ? 100 : e <= 120 ? 1e3 : 1e4, H = () => "[iFrameSizer]ID:0:false:false:32:true:true::auto:::0:false:child:auto:true:::true:::false";
function P(e) {
  if (typeof e.data == "string" && e.data.startsWith("[iFrameSizer]")) {
    const [t, n] = e.data.split(":"), i = +n;
    return i > 0 ? i : null;
  }
  return null;
}
const v = q();
let l = [];
const K = (e, t) => {
  if (!p())
    return [];
  const n = { ...k(), ...A(e ?? {}) }, i = W(t), o = x(n, i);
  return i.map((r) => {
    const s = {
      iframe: r,
      settings: n,
      interactionState: { isHovered: !1 },
      initContext: { isInitialized: !1, retryAttempts: 0 }
    }, a = F(s, o);
    return l.push(s), {
      unsubscribe: () => {
        a(), l = l.filter((d) => d.iframe !== r);
      }
    };
  });
};
function W(e) {
  return typeof e == "string" ? Array.from(document.querySelectorAll(e)).filter(b) : e ? b(e) ? [e] : [] : Array.from(document.getElementsByTagName("iframe"));
}
function x(e, t) {
  if (Array.isArray(e.checkOrigin))
    return e.checkOrigin;
  if (!e.checkOrigin)
    return [];
  const n = [];
  for (const i of t) {
    const o = D(i);
    o && n.push(o);
  }
  return n;
}
function F(e, t) {
  const n = B(e.iframe) ? U(e) : N(e, t), i = $(e);
  return () => {
    n(), i();
  };
}
function N(e, t) {
  const {
    iframe: n,
    initContext: i,
    settings: { checkOrigin: o, enableLegacyLibSupport: r, targetElementSelector: s, bodyPadding: a, bodyMargin: d }
  } = e, h = (c) => {
    var y;
    const E = !o || t.includes(c.origin);
    if (!(!(n.contentWindow === c.source) || !E)) {
      if (((y = c.data) == null ? void 0 : y.type) === "iframe-resized") {
        const { height: u } = c.data;
        u && g({ newHeight: u, registeredElement: e });
        return;
      }
      if (r) {
        const u = P(c);
        u !== null && g({ newHeight: u, registeredElement: e });
        return;
      }
    }
  };
  window.addEventListener("message", h);
  const S = r ? H() : { type: "iframe-child-init", targetElementSelector: s, bodyPadding: a, bodyMargin: d }, w = () => {
    T(n, () => {
      var c;
      return (c = n.contentWindow) == null ? void 0 : c.postMessage(S, "*");
    }), i.retryAttempts++, i.retryTimeoutId = window.setTimeout(w, m(i.retryAttempts));
  };
  return w(), () => window.removeEventListener("message", h);
}
function U(e) {
  const { iframe: t, settings: n } = e, { targetElementSelector: i } = n;
  let o = 0;
  const r = () => {
    const s = f(t.contentDocument, i);
    if (!t.contentDocument || !s)
      return o++, setTimeout(r, m(o));
    I(t.contentDocument, n), v().observe(s);
  };
  return C(t, r), () => {
    const s = f(t.contentDocument, i);
    s && v().unobserve(s), t.removeEventListener("load", r);
  };
}
function $({ iframe: e, interactionState: t }) {
  const n = () => {
    t.isHovered = !0;
  }, i = () => {
    t.isHovered = !1;
  };
  return e.addEventListener("mouseenter", n), e.addEventListener("mouseleave", i), () => {
    e.removeEventListener("mouseenter", n), e.removeEventListener("mouseleave", i);
  };
}
function q() {
  let e = null;
  return () => {
    if (!e) {
      const t = ({ target: n }) => {
        const i = l.find(({ iframe: d }) => d.contentDocument === n.ownerDocument);
        if (!i)
          return;
        const { iframe: o, settings: r } = i, s = f(o.contentDocument, r.targetElementSelector);
        if (!s)
          return;
        const { height: a } = L(s);
        a && g({ newHeight: a, registeredElement: i });
      };
      e = new ResizeObserver((n) => n.forEach(t));
    }
    return e;
  };
}
function g({ registeredElement: e, newHeight: t }) {
  const { iframe: n, settings: i, interactionState: o, initContext: r } = e;
  r.isInitialized || (r.isInitialized = !0, clearTimeout(r.retryTimeoutId));
  const s = n.getBoundingClientRect(), a = t + i.offsetSize;
  if (n.style.height = `${a}px`, !i.onIframeResize)
    return;
  const d = {
    iframe: n,
    settings: { ...i },
    interactionState: { ...o },
    previousRenderState: { rect: s },
    nextRenderState: { rect: n.getBoundingClientRect() }
  };
  i.onIframeResize(d);
}
const V = G();
let z = !1;
_();
function _() {
  !p() || !R() || window.addEventListener("message", (e) => {
    var t;
    ((t = e.data) == null ? void 0 : t.type) === "iframe-child-init" && M(() => O(e));
  });
}
function O(e, t = 0) {
  const { targetElementSelector: n, bodyPadding: i, bodyMargin: o } = e.data, r = f(document, n);
  if (z || window.parent !== e.source)
    return;
  if (!r)
    return setTimeout(() => O(e, t + 1), m(t));
  I(document, { bodyMargin: o, bodyPadding: i });
  const s = V();
  s.disconnect(), s.observe(r), z = !0;
}
function G() {
  let e = null;
  return () => (e || (e = new ResizeObserver((t) => {
    if (!t[0].target)
      return;
    const { height: n, width: i } = L(t[0].target), o = {
      type: "iframe-resized",
      width: i,
      height: n
    };
    window.parent.postMessage(o, "*");
  })), e);
}
const Q = ({ previousRenderState: e, nextRenderState: t, iframe: n }) => {
  document.activeElement === n && window.scrollBy(0, t.rect.bottom - e.rect.bottom);
};
export {
  K as initialize,
  _ as initializeChildListener,
  Q as updateParentScrollOnResize
};